/**
 * The file extension for a saved post. Most file addresses end in one ("x.jpg"), but some sources hand out addresses with none (Paheal:
 * https://r34i.paheal-cdn.net/77/65/7765f7...), and taking "whatever follows the last dot" then gave names like "booru_1.net/77/65/7765f7...".
 * So: the address's own ending when it has a real one, else the file's type, else what the post's kind suggests.
 */
const MIME_EXT: Record<string, string> = {
  "image/jpeg": "jpg",
  "image/jpg": "jpg",
  "image/png": "png",
  "image/gif": "gif",
  "image/webp": "webp",
  "image/avif": "avif",
  "video/mp4": "mp4",
  "video/webm": "webm",
  "video/quicktime": "mov",
  "video/x-matroska": "mkv",
  "audio/mpeg": "mp3",
  "audio/ogg": "ogg",
  "audio/wav": "wav",
}

export function downloadExtension(url: string, kind?: string | null, mime?: string | null): string {
  let path = url
  try {
    path = new URL(url, "http://x.invalid").pathname
  } catch {
    path = url.split("?")[0].split("#")[0]
  }
  const last = path.split("/").pop() ?? ""
  const ending = /\.([a-z0-9]{2,5})$/i.exec(last)
  if (ending) return ending[1].toLowerCase()
  const fromMime = mime ? MIME_EXT[mime.split(";")[0].trim().toLowerCase()] : undefined
  if (fromMime) return fromMime
  if (kind === "video") return "mp4"
  if (kind === "audio") return "mp3"
  return "jpg"
}
